export enum CleanupType {
  VM_IMAGES = 'vm-images',
  DOCKER_IMAGES = 'docker-images',
  DISKS = 'disks',
  MACHINE_IMAGES = 'machine-images',
  STATIC_IPS = 'static-ips'
}

export interface CleanupItem {
  name: string;
  sizeGb: number;
  createdAt: string;
  details: string;
}

export interface CleanupReport {
  type: CleanupType;
  projectId: string;
  unused: CleanupItem[];
  unusedSizeGb: number;
  keptCount: number;
  warnings: string[];
  note: string;
  isDeleting: boolean;
}

export interface CleanupDeleteStarted {
  started: number;
  skipped: string[];
}
